import { RootState } from "store/store";
import { IDataset } from "./types";
export const selectUserDataLoading = (state: RootState): boolean => state.userData.loading
export const selectDatasetsList = (state: RootState): IDataset[] => state.userData.datasetsList
export const selectIsDatasetChanged = (state: RootState): boolean => state.userData.isDatasetChanged
